export const makeRelayState = relayState => relayState;